// extracted by mini-css-extract-plugin
module.exports = {"promotion-messages-wrapper":"PromotionInput_promotion-messages-wrapper__2xHO3","no-promotion-msg":"PromotionInput_no-promotion-msg__39rrz"};